var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';

var Parked = function Parked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 13 13",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "Parked_a",
    d: "M762.69 1647.43a4 4 0 0 0-.91.07v2.92c.19.04.41.06.75.06 1.18 0 1.92-.6 1.92-1.6 0-.9-.63-1.45-1.76-1.45"
  }), React.createElement("path", {
    id: "Parked_b",
    d: "M767.7 1644h-10.4c-.71 0-1.3.58-1.3 1.3v10.4c0 .72.59 1.3 1.3 1.3h10.4c.71 0 1.3-.58 1.3-1.3v-10.4c0-.72-.59-1.3-1.3-1.3m-1.95 7.16a4.64 4.64 0 0 1-3.21 1.04c-.3 0-.56-.02-.76-.06v3.55h-2.21v-9.96h3.01c1.38 0 2.36.27 3.02.8.64.5 1.05 1.31 1.05 2.28 0 .97-.3 1.8-.9 2.35"
  })), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Parked_a",
    transform: "translate(-756 -1644)"
  }), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Parked_b",
    transform: "translate(-756 -1644)"
  }));
};

export default Parked;